import { createAsyncThunk } from "@reduxjs/toolkit";
import { forgotPassword as asyncForgetPwd, ResetPassword as asyncResetPassword } from "../../../helpers/apis";

export const forgotPassword = createAsyncThunk(
    'forgotPassword/forgotPassword',
    async (data, thunkAPI) => {
        try {
            const response = await asyncForgetPwd(data);

            if (response.error) {
                // API returned an error
                toast.error(response.msg);
                return thunkAPI.rejectWithValue(response.msg);
            }

            // API call was successful
            toast.success(response.msg);
            return response.msg; // Pass success message to reducer
        } catch (error) {
            const errorMsg = error.response ? error.response.msg : "An error occurred";
            toast.error(errorMsg);
            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);

export const resetPassword = createAsyncThunk(
    'forgotPassword/resetPassword',
    async (data, thunkAPI) => {

        try {
            const response = await asyncResetPassword(data);
            if (response.error) {
                // API returned an error
                toast.error(response.msg);
                return thunkAPI.rejectWithValue(response.msg);
            }

            toast.success(response.msg);
            return response.msg;
        } catch (error) {
            // Extract error message properly
            let errorMsg = "An error occurred"; // Default message

            if (error.response) {
                if (error.response.data) {
                    errorMsg = error.response.data.msg || error.response.data.error || error.response.data.message || JSON.stringify(error.response.data);
                } else {
                    errorMsg = error.response.statusText || "Server error";
                }
            } else if (error.message) {
                errorMsg = error.message;
            }

            // Show toast notification with the error message
            toast.error(errorMsg);

            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);
